export const EXTERNAL_HOMEPAGE_URL_MAX_LENGTH = 512;

// Mirrors the server-side UpdatePlusWebsiteExternalHomepageUrlRequest rules.
export function validateExternalHomepageUrl(value: string): string | null {
  if (!/^https?:\/\//i.test(value)) return 'URL must start with http:// or https://';
  if (value.length > EXTERNAL_HOMEPAGE_URL_MAX_LENGTH) {
    return `URL must be ${EXTERNAL_HOMEPAGE_URL_MAX_LENGTH} characters or fewer`;
  }
  try {
    // eslint-disable-next-line no-new
    new URL(value);
  } catch {
    return 'Enter a valid URL';
  }
  return null;
}
